import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ApiState } from './types';
import { RootState } from './../types';

export const state: ApiState = {
    ongoingRequests: 0,
    serviceDownIntervalShortEval: 0,
    serverHost: '',
    url: '',
    isIntensiveUsedApi: false,
    response: {
        isBadRequest: false,
        httpCode: 0,
        code: '',
        message: ''
    },
    data: {
        vehicles: {}
    }
};

const namespaced: boolean = true;

export const api: Module<ApiState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};